import React from 'react';

import './style.scss';

function AboutEvent(){
  return (
    <div className="about-event">
      <article className="about-event__content layout">
        <header className="about-event__header">
          <h2 className="about-event__title">
            درباره استارت‌آپ ریلیتی
          </h2>
        </header>
        <div className="about-event__desc">
        کسب و کارها بیشتر مواقع با امید، احساسات و سرشار از انرژی آغاز می‌شن. این احساسات همیشه در درون ما نوید موفقیت می‌دن ولی برای داشتن دیدی باز به واقعیت‌ها مانع بزرگی هستن.<br></br>
کارآفرینان جوان اغلب اوقات از این‌که آینه آرزوها بسیار شکننده‌ست غافلن و از ناممکن‌های ممکن صحبت می‌کنن.<br></br>
رویداد «استارت‌آپ ریلیتی» از واقعیت‌ها و دشواری‌های این راه شیرین حرف‌های زیادی برای گفتن داره.<br></br>
ما معتقدیم در هر کاری نشون دادن موانع و مسیرهای پر پیچ و خم مهم تر از نشون دادن یک مسیر هموار و پر از گل‌های سرخ و زیباست.<br></br>
همراه ما باشید، صحبت های زیادی با شما داریم.
        </div>
      </article>
    </div>
  );
}

export default AboutEvent;